import { FormContent, Wrapper } from '@maxtropy/components';
import { Button, Col, Form, Modal, Row, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import styles from '../index.module.scss';
import SelectTemplate from './SelectTemplate';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { getTenantInfo, getTenantList, TemplateAssign, TenantListRes } from '../../../api/tenantAttribute';
import ShowInput from '@/shared/components/ShowInput';

const routes = [{ name: 'Iot配置' }, { name: '设备信息模板库' }, { name: '模板分配' }, { name: '属性模板分配' }];

const formLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 18 },
};

interface ValuesProps {
  code: string;
  name: string;
  template: TenantListRes[];
}

const TemplateDistribution: React.FC = () => {
  const [form] = Form.useForm();
  const { id } = useParams<{ id: string }>();
  const { search } = useLocation();
  const navigate = useNavigate();
  const [template, setTemplate] = useState<TenantListRes[]>([]);
  const [modalApi, modalContextHolder] = Modal.useModal();

  useEffect(() => {
    if (id) {
      getTenantInfo(id).then(data => {
        form.setFieldsValue(data);
      });
      getTenantList(id).then(res => {
        form.setFieldsValue({
          template: res,
        });
        setTemplate(res);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goList = () => {
    navigate(`/device/info/distribution${search}`);
  };

  const onCacel = () => {
    modalApi.confirm({
      title: null,
      icon: null,
      content: <div>是否放弃所有未保存信息并返回列表？</div>,
      onOk: goList,
    });
  };

  const onFinish = (value: ValuesProps) => {
    if (id) {
      const currentIds = (value.template ?? []).map(i => i.id);
      const templatesId = template.map(i => i.id);
      let params = {};
      if (templatesId.length === 0) {
        params = {
          addTemplateIds: currentIds,
        };
      } else {
        params = {
          deleteTemplateIds: templatesId.filter(i => !currentIds.includes(i)),
          addTemplateIds: currentIds.filter(i => !templatesId.includes(i)),
        };
      }
      TemplateAssign({ mcid: id, ...params }).then(res => {
        if (res) goList();
      });
    }
  };

  return (
    <Wrapper routes={routes} className={styles.wrapper}>
      <Form form={form} layout="vertical" onFinish={onFinish} {...formLayout}>
        <FormContent title="租户信息">
          <Row className={styles.row}>
            <Col span={12} className={styles.col}>
              <Form.Item label="租户code" name="tenantCode">
                <ShowInput />
              </Form.Item>
            </Col>
            <Col span={12} className={styles.col}>
              <Form.Item label="租户名称" name="name">
                <ShowInput />
              </Form.Item>
            </Col>
          </Row>
        </FormContent>
        <FormContent title="属性信息模板">
          <Form.Item name="template" wrapperCol={{ span: 24 }}>
            <SelectTemplate />
          </Form.Item>
        </FormContent>
        <Space className="sticky-footer">
          <Button type="primary" htmlType="submit">
            保存
          </Button>
          <Button className={styles.button} onClick={onCacel}>
            取消
          </Button>
        </Space>
      </Form>
      {modalContextHolder}
    </Wrapper>
  );
};

export default TemplateDistribution;
